if (!window.sectionAccordionsInit) {
  window.sectionAccordionsInit = true;

  const TRIGGER = '[data-section-type="accordions"] [data-collapsible-trigger]';
  const DURATION = 500;

  const setExpanded = (trigger, expanded) => {
    const container = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!container) return;
    const content = container.querySelector('[data-collapsible-content]');

    clearTimeout(container.accordionTimer);
    container.style.height = `${content.offsetHeight}px`;
    trigger.classList.toggle('is-expanded', expanded);
    trigger.setAttribute('aria-expanded', expanded);
    container.classList.toggle('is-expanded', expanded);

    if (expanded) {
      container.accordionTimer = setTimeout(() => (container.style.height = 'auto'), DURATION);
    } else {
      requestAnimationFrame(() => (container.style.height = '0px'));
      container.accordionTimer = setTimeout(() => (container.style.height = ''), DURATION);
    }
  };

  const toggle = (trigger, expanded = !trigger.classList.contains('is-expanded')) => {
    if (expanded) {
      trigger
        .closest('[data-collapsible-single]')
        ?.querySelectorAll('[data-collapsible-trigger].is-expanded')
        .forEach((other) => other !== trigger && setExpanded(other, false));
    }
    setExpanded(trigger, expanded);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER);
    if (!trigger) return;
    event.preventDefault();
    toggle(trigger);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const trigger = event.target.querySelector(TRIGGER);
    if (trigger) toggle(trigger, true);
  });
}
